import { Typography } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";
import { Close } from "@material-ui/icons";
import { useCart } from "../../../hooks";
import { PROMO_CODE_TYPES } from "../../PromoCodeManager/constants";
import { currencyFormatter } from "../../PromoCodeManager/utils";

const StyledDiscount = styled("span")(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.green.main,
}));

const StyledSpan = styled("span")(() => ({
  display: "inline-flex",
  alignItems: "center",
}));

const StyledButton = styled("button")(({ theme }) => ({
  alignItems: "center",
  background: "none",
  border: "none",
  color: theme.palette.text.secondary,
  cursor: "pointer",
  display: "inline-flex",
  font: "inherit",
  justifyContent: "center",
  margin: 0,
  padding: 0,

  "& svg": {
    height: "1rem",
  },

  "&:hover": {
    color: theme.palette.text.primary,
  },
}));

async function removePromoCode() {
  try {
    const response = await window.fetch("/api/promoCode/updateCart", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ code: null }),
    });

    if (!response.ok) {
      throw new Error("Failed to remove promo code");
    }
  } catch (err) {
    console.error(err);
  }
}

function discountFor(promoCode) {
  if (!promoCode) {
    return null;
  }

  if (promoCode.type === PROMO_CODE_TYPES.CENTS) {
    return `(Up to ${currencyFormatter.format(
      promoCode.discountCents / 100,
    )} off)`;
  }

  if (promoCode.type === PROMO_CODE_TYPES.PERCENTAGE) {
    return `(${promoCode.discountPercentage * 100}% off)`;
  }

  return null;
}

function tagScopeSummary({ cart }) {
  const { promoCode, shipmentGroups } = cart;

  if (!promoCode?.productTagString) {
    return null;
  }

  let eligibleCount = 0;
  let totalCount = 0;

  shipmentGroups.forEach((group) => {
    Object.values(group.itemized).forEach((item) => {
      totalCount += 1;
      if (item.promoCodeDiscount < 0) {
        eligibleCount += 1;
      }
    });
  });

  return `Applied to ${eligibleCount} of ${totalCount} item${
    totalCount !== 1 ? "s" : ""
  }`;
}

export default function PromoCode() {
  const { cart, refresh } = useCart();
  const { promoCode } = cart;

  const onClick = async () => {
    await removePromoCode();
    refresh();
  };

  if (!promoCode) {
    return null;
  }

  const summary = tagScopeSummary({ cart });

  return (
    <>
      <Typography variant="body2" color="textSecondary">
        Promo Code: <strong>{promoCode?.code}</strong>{" "}
        <StyledSpan>
          {discountFor(promoCode)}
          <StyledButton title="Remove Promo Code" onClick={onClick}>
            <Close />
          </StyledButton>
        </StyledSpan>
        {summary && (
          <Typography variant="caption" color="textSecondary" component="span">
            {" "}
            — {summary}
          </Typography>
        )}
      </Typography>

      <StyledDiscount>
        {cart.totals.promoCodeDiscount.formattedPrice}
      </StyledDiscount>
    </>
  );
}
